import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { CardTypesEnum } from '@common-fe/common-fe';
import { isString } from 'lodash';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL } from '@/dtos';

interface ServiceTypeMap {
  [key: string]: string;
}

export const replaceRxWithPharmacyType = (planTypes: string[] = []) =>
  planTypes.map((type) => (type === CardTypesEnum.RX ? PHARMACY_TYPE : type));
export const QUERY_KEY = 'GET_SERVICE_TYPE';
export const PHARMACY_TYPE = 'PHARMACY';

export default (
  visible: boolean,
  payoutDefinitionId: string,
  planTypes?: string[],
  deductibleServiceType?: string,
  plans?: string[],
  disableCache = false
) => {
  const updatedPlanTypes = replaceRxWithPharmacyType(planTypes || []);
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, payoutDefinitionId, deductibleServiceType, updatedPlanTypes, plans],
    () =>
      api.get(API_URL.PAYOUT_DEFINITIONS_SERVICES_BY_ID(payoutDefinitionId), {
        params: {
          type: deductibleServiceType,
          categories: updatedPlanTypes,
          ...(plans && plans.length > 0 && { plan_ids: plans.filter((plan) => isString(plan)).join(',') }),
        },
      }),
    {
      enabled: visible && !!payoutDefinitionId && !!updatedPlanTypes && !!deductibleServiceType,
      ...(disableCache && {
        cacheTime: 0,
        staleTime: 0,
      }),
    }
  );

  const fieldOptions = useMemo(() => {
    const list = data?.data || [];
    return list.map((item) => {
      const formatedItem: Option = {
        key: `${item.id || 0}`,
        value: item.name,
        name: item.name,
        title: item.name,
      };
      return formatedItem;
    });
  }, [data]);
  const fieldsMap = useMemo(() => {
    const fieldMap: ServiceTypeMap = {};
    fieldOptions.forEach((item) => {
      fieldMap[`${item.key}`] = `${item.value}`;
    });
    return fieldMap;
  }, [fieldOptions]);
  return {
    isLoading,
    isSuccess,
    fieldOptions,
    fieldsMap,
  };
};
